export default "__VITE_ASSET__BgYfGVf0__"